// Nevalora product page: variant buttons, gallery slider, zoom and size guide.
// Variant changes re-render the section from Shopify so the price, images and
// variant ID always match what Shopify resolved on the server.
if (!window.nevaloraProductOptionsInitialized) {
  window.nevaloraProductOptionsInitialized = true;

  let activeRequest;

  document.addEventListener('change', async (event) => {
    const input = event.target.closest?.('.fs-product-section [data-option-input]');
    if (!input) return;

    const section = input.closest('.fs-product-section');
    const groups = [...section.querySelectorAll('[data-option-group]')];
    const selectedIds = groups.map(
      (group) => group.querySelector('[data-option-input]:checked')?.dataset.optionValueId
    );
    if (selectedIds.some((id) => !id)) return;

    activeRequest?.abort();
    const request = new AbortController();
    activeRequest = request;

    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.delete('variant');
    pageUrl.searchParams.set('option_values', selectedIds.join(','));

    const sectionUrl = new URL(pageUrl);
    sectionUrl.searchParams.set('section_id', section.dataset.sectionId);

    const button = section.querySelector('.fs-add-btn');
    if (button) {
      button.disabled = true;
      button.textContent = 'Updating…';
    }
    section.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(sectionUrl, { credentials: 'same-origin', signal: request.signal });
      if (!response.ok) throw new Error('Variant section request failed');

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = html.querySelector('.fs-product-section');
      if (!updated || updated.dataset.sectionId !== section.dataset.sectionId) {
        throw new Error('Variant section was missing');
      }
      if (request.signal.aborted) return;

      const groupIndex = groups.indexOf(input.closest('[data-option-group]'));
      section.replaceWith(updated);
      window.history.replaceState(window.history.state, '', pageUrl);
      updated
        .querySelectorAll('[data-option-group]')
        [groupIndex]?.querySelector('[data-option-input]:checked')
        ?.focus();
    } catch (error) {
      if (error.name === 'AbortError') return;
      // A full page load is safer than leaving an old variant ID ready to submit.
      window.location.assign(pageUrl.toString());
    }
  });

  // Add to Bag without leaving the page: add via the Cart API, refresh the bag and open it.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('form.fs-product-form');
    if (!form || !window.fetch) return;
    event.preventDefault();

    const button = form.querySelector('.fs-add-btn');
    const label = button ? button.textContent : '';
    let error = form.querySelector('[data-add-error]');
    if (error) error.remove();
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');

      if (window.nvRefreshCart) await window.nvRefreshCart();
      if (button) button.textContent = 'Added to bag';
      if (window.nvOpenDrawer) window.nvOpenDrawer('nv-cart');
      setTimeout(() => {
        if (button) {
          button.textContent = label;
          button.disabled = false;
        }
      }, 1600);
    } catch (err) {
      if (button) {
        button.textContent = label;
        button.disabled = false;
      }
      error = document.createElement('p');
      error.setAttribute('data-add-error', '');
      error.setAttribute('role', 'alert');
      error.style.cssText = 'margin:10px 0 0;font-size:13px;color:#b42318;';
      error.textContent = err.message;
      (button || form).after(error);
    }
  });

  const trackOf = (el) => el.closest('[data-gallery]')?.querySelector('[data-gallery-track]');

  document.addEventListener('click', (event) => {
    const target = event.target;

    const nav = target.closest?.('[data-gallery-nav]');
    if (nav) {
      const track = trackOf(nav);
      if (track) track.scrollBy({ left: (nav.dataset.galleryNav === 'next' ? 1 : -1) * track.clientWidth });
      return;
    }

    const dot = target.closest?.('[data-gallery-dot]');
    if (dot) {
      const track = trackOf(dot);
      if (track) track.scrollTo({ left: Number(dot.dataset.galleryDot) * track.clientWidth });
      return;
    }

    const zoomTrigger = target.closest?.('[data-zoom-src]');
    if (zoomTrigger) {
      const dialog = zoomTrigger.closest('.fs-product-section')?.querySelector('[data-zoom-dialog]');
      const image = dialog?.querySelector('[data-zoom-image]');
      if (!dialog || !image || !dialog.showModal) return;
      image.src = zoomTrigger.dataset.zoomSrc;
      image.alt = zoomTrigger.querySelector('img')?.alt || '';
      image.classList.remove('is-zoomed');
      dialog.showModal();
      return;
    }

    if (target.matches?.('[data-zoom-image]')) {
      target.classList.toggle('is-zoomed');
      return;
    }

    const opener = target.closest?.('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog?.showModal) dialog.showModal();
      return;
    }

    const closer = target.closest?.('[data-dialog-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // Clicking the dimmed backdrop closes the drawer.
    if (target.matches?.('dialog.fs-dialog--drawer')) target.close();
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target.closest?.('[data-gallery-track]');
      if (!track || !track.clientWidth) return;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      const gallery = track.closest('[data-gallery]');
      gallery.querySelectorAll('[data-gallery-dot]').forEach((dot, i) => {
        dot.setAttribute('aria-current', String(i === index));
      });
      const count = gallery.querySelector('[data-gallery-count]');
      if (count) count.textContent = String(index + 1);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    const track = event.target.closest?.('[data-gallery-track]');
    if (!track || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
    event.preventDefault();
    track.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * track.clientWidth });
  });
}
